import { Button, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "./Styles/TableAndCellStyles";


export default function PaymentLogsTable({handleClickViewDetails, tableContent=[]}){
    return(
        <TableContainer>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell>Tenant</StyledTableCell>
                        <StyledTableCell>Tenant Contact</StyledTableCell>
                        <StyledTableCell>Unit</StyledTableCell>
                        <StyledTableCell>Severity</StyledTableCell>
                        <StyledTableCell>Error</StyledTableCell>
                        <StyledTableCell>Actions</StyledTableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {tableContent.length > 0 ? tableContent.map((row, index)=>{
                        return(
                            <StyledTableRow key={index}>
                                <StyledTableCell>{row.related_occupancy.related_tenant.first_name+" "+row.related_occupancy.related_tenant.last_name}</StyledTableCell>
                                <StyledTableCell>{row.related_occupancy.related_tenant.phonenumber}</StyledTableCell>
                                <StyledTableCell>{row.related_occupancy.related_rental_unit.unit_name}</StyledTableCell>
                                <StyledTableCell>{row.log_severity}</StyledTableCell>
                                <StyledTableCell>{row.error}</StyledTableCell>
                                <StyledTableCell><Button variant="outlined" onClick={()=>handleClickViewDetails(row)}>View Details</Button></StyledTableCell>
                            </StyledTableRow>
                        )
                    }):(
                        <StyledTableRow>
                            <StyledTableCell colSpan={6}>No Data Available</StyledTableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}